import PriceStackLuxPlusProminentPrice from 'components/Luxkit/PricePoints/LuxPlus/PriceStackLuxPlusProminentPrice'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import React, { useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { checkCanViewLuxPlusBenefits, isLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import PriceRowLuxPlusPriceBox from 'components/Luxkit/PricePoints/LuxPlus/PriceRowLuxPlusPriceBox'
import PriceStackPriceWithLoyaltyLeadWithLuxPlusPrice from 'components/Luxkit/PricePoints/PriceStackPriceWithLoyaltyLeadWithLuxPlusPrice'

interface Props {
  price: number;
  memberPrice?: number;
  offerConfig?: App.OfferLuxPlusConfig;
}

function PackageUpgradePriceStack(props: Props) {
  const {
    offerConfig,
    price,
    memberPrice = 0,
  } = props

  const canViewLuxPlusBenefits = useAppSelector(checkCanViewLuxPlusBenefits)
  const luxPlusEnabled = useAppSelector(isLuxPlusEnabled)
  const displayedMode = useMemo(() => {
    if (!luxPlusEnabled) {
      return 'regular-only'
    } else if (!canViewLuxPlusBenefits && memberPrice > 0) {
      return 'regular-prominent'
    } else if (offerConfig?.access === 'memberOnly') {
      return 'member-only'
    } else if (canViewLuxPlusBenefits && memberPrice > 0) {
      return 'member-prominent'
    } else {
      return 'regular-only'
    }
  }, [canViewLuxPlusBenefits, offerConfig?.access, luxPlusEnabled, memberPrice])
  switch (displayedMode) {
    case 'member-only':
      return <PriceRowLuxPlusPriceBox
        memberPrice={memberPrice || price}
        size="M"
        saleUnit=""
        horizontalAlign="start"
      />
    case 'regular-only':
      return <PriceRowPrice
        price={price}
        saleUnit=""
        size="M"
        signDisplay="always"
      />
    case 'member-prominent':
      return <PriceStackLuxPlusProminentPrice
        memberPrice={memberPrice}
        saleUnit=""
        nonMemberPrice={price}
        size="M"
        memberPriceSignDisplay="always"
        nonMemberPriceSignDisplay="always"
        orientation="vertical"
        horizontalAlign="start"
      />
    case 'regular-prominent':
      return <PriceStackPriceWithLoyaltyLeadWithLuxPlusPrice
        memberPrice={memberPrice}
        saleUnit=""
        nonMemberPrice={price}
        size="M"
        signDisplay="always"
        horizontalAlign="start"
        orientation="vertical"
      />
  }
}

export default PackageUpgradePriceStack
